import ClockIcon from 'components/atoms/icons/clock.svg?react';

import useSlaTimer from './use-sla-timer';
import s from './styles.module.scss';

import type { FC } from 'react';

type Props = {
  slaDeadline: number;
};

const Countdown: FC<Props> = ({ slaDeadline }) => {
  const { countdown } = useSlaTimer({ slaDeadline });
  return (
    <p data-cy="reading-priority-countdown" className={s.wrapper}>
      <ClockIcon /> {countdown}
    </p>
  );
};

export default Countdown;
